import React, { useEffect, useState, useRef, useLayoutEffect, useCallback } from "react";

export const DropdownMenu2 = ({
  options,
  isLoading,
  onSelect,
  containerRef,
}) => {
  const [dropDirection, setDropDirection] = useState("bottom");
  const dropdownRef = useRef(null);

  const calculateDropDirection = useCallback(() => {
    if (!dropdownRef.current) return;

    const parentRect =
      dropdownRef.current.parentElement.getBoundingClientRect();
    const dropdownHeight = dropdownRef.current.scrollHeight + 200 || 250;
    const viewportHeight =
      containerRef?.current?.innerHeight || window.innerHeight;

    const spaceAbove = parentRect.top;
    const spaceBelow = viewportHeight - parentRect.bottom;

    if (spaceBelow >= dropdownHeight || spaceBelow > spaceAbove) {
      setDropDirection("bottom");
    } else {
      setDropDirection("top");
    }
  }, [containerRef]);

  useLayoutEffect(() => {
    calculateDropDirection();
  }, [options, calculateDropDirection]);

  useEffect(() => {
    window.addEventListener("resize", calculateDropDirection);
    return () => {
      window.removeEventListener("resize", calculateDropDirection);
    };
  }, [calculateDropDirection]);

  const handleSelect = (option) => {
    onSelect(option);
  };

  const positionClasses = {
    top: "bottom-full mb-1",
    bottom: "top-full mt-1",
  };

  const dropdownContent = isLoading ? (
    <div className="text-sm text-center text-ink-gray-400 dark:text-ink-copy-hover p-3">
      Loading...
    </div>
  ) : (
    options.map((option, index) => (
      <div
        key={index}
        onClick={() => handleSelect(option)}
        className="px-4 py-2 m-1 rounded-lg flex items-center justify-between text-sm cursor-pointer hover:bg-fill-gray-500/20"
      >
        <span className="truncate">{option.name}</span>
      </div>
    ))
  );

  return (
    <div
      ref={dropdownRef}
      className={`absolute left-0 w-[200px] max-h-[${
        isLoading ? "250px" : "200px"
      }] overflow-y-auto show-scrollbar z-50 rounded-lg bg-fill-white dark:bg-fill-panel-surface border border-edge-hex-6d808d4d dark:border-edge-hex-66666666 transition-all duration-300 ${
        positionClasses[dropDirection]
      }`}
    >
      {dropdownContent}
    </div>
  );
};

export const DropdownMenu = ({
  options,
  isLoading,
  onSelect,
}) => {
  const [dropDirection, setDropDirection] = useState("bottom");
  const dropdownRef = useRef(null);

  const calculateDropDirection = () => {
    if (!dropdownRef.current) return;

    const parentRect =
      dropdownRef.current.parentElement.getBoundingClientRect();
    const dropdownHeight = dropdownRef.current.scrollHeight + 200 || 250;
    const viewportHeight = window.innerHeight;

    const spaceAbove = parentRect.top;
    const spaceBelow = viewportHeight - parentRect.bottom;

    if (spaceBelow >= dropdownHeight || spaceBelow > spaceAbove) {
      setDropDirection("bottom");
    } else {
      setDropDirection("top");
    }
  };

  useLayoutEffect(() => {
    calculateDropDirection();
  }, [options]);

  useEffect(() => {
    window.addEventListener("resize", calculateDropDirection);
    return () => {
      window.removeEventListener("resize", calculateDropDirection);
    };
  }, []);

  const handleSelect = (option) => {
    onSelect(option);
  };

  const positionClasses = {
    top: "bottom-full mb-1",
    bottom: "top-full mt-1",
  };

  const dropdownContent = isLoading ? (
    <div className="text-sm text-center text-ink-gray-400 dark:text-ink-copy-hover p-3">
      Loading...
    </div>
  ) : (
    options.map((option, index) => (
      <div
        key={index}
        onClick={() => handleSelect(option)}
        className="px-4 py-2 m-1 rounded-lg flex items-center justify-between text-sm cursor-pointer hover:bg-fill-gray-500/20"
      >
        <span className="truncate">{option.name}</span>
      </div>
    ))
  );

  return (
    <div
      ref={dropdownRef}
      className={`absolute left-0 w-[200px] max-h-[${
        isLoading ? "250px" : "200px"
      }] overflow-y-auto z-50 rounded-lg bg-fill-white dark:bg-fill-panel-surface border border-edge-hex-6d808d4d dark:border-edge-hex-66666666 transition-all duration-300 ${
        positionClasses[dropDirection]
      }`}
    >
      {dropdownContent}
    </div>
  );
};

export default DropdownMenu;
